import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

export const selectStepperState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.stepperActividad
);

export const selectStepperActividad = createSelector(
  selectStepperState,
  (steppers) => steppers.step
);
